import { render, staticRenderFns } from "./novasoft-sht.vue?vue&type=template&id=0c4ac419"
import script from "./novasoft-sht.vue?vue&type=script&lang=js"
export * from "./novasoft-sht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports